import { render, staticRenderFns } from "./UserEventManager.vue?vue&type=template&id=62847888"
import script from "./UserEventManager.vue?vue&type=script&lang=js"
export * from "./UserEventManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports